import React, { useState } from "react";
import Navbar from "./navbar";
import Footer from "./footer";
import "../index.css";
import "../SourceReportDetails.css";

 const BASE_URL = process.env.REACT_APP_DATA_FEEDER;
const token = window.sessionStorage.getItem("jwtToken");
sessionStorage.setItem("xApiKey", "securedBIdatafeederAPIkeyOne");

const apiMap = {
  table1: {
    header: "Data Feeder Main Collection",
    sections: [
      {
        mainNote:
          "If daily stock data is missing use this for inserting the missing data for the date-range, it also accepts the SET of stockNames so you can persist multiple data for multiple dates at same time.",
        subtitle: "Daily Sourcing",
        apis: [
          {
            name: "Source Daily Stock Price",
            endpoint: "/symbolDailyPrice",
            note: "Can source daily stocks data for specific period of time or for specific Set of stocks by passing stocks in ',' separated manner. [ex. TCS,INFY]",
            needsStock: true,
            needsDateRange: true,
          },
        ],
      },
      {
        mainNote:
          "If Valuation data is missing use this for inserting the missing data for the date-range, Instead of Inserting it will Updates the data for same month (One row for each month per symbol). Here if the date range is used it will persist Latest data present for each month For that symbol. it also accepts the SET of stockNames so you can persist multiple data for multiple dates at same time.",
        subtitle: "Weekly Sourcing",
        apis: [
          {
            name: "Symbol Valuation Data",
            endpoint: "/latest/valuation",
            note: "Can source valuation stocks data for specific Set of stocks by passing stocks in ',' separated manner. [ex. TCS,INFY]",
            needsStock: true,
            needsDateRange: true,
          },
        ],
      },
    ],
  },

  table2: {
    header: "Quarterly Individual sourcing",
    mainNote:
      "If you have missing data for some stocks in quarterly tables use the 1st endpoint. The first endpoint will persist all Historically missing data for all Quarterly tables alone, No need to hit the remaining endpoints.",
    showStockColumn: true,
    sections: [
      {
        subtitle: "Source complete history of stock for quarterly",
        apis: [
          {
            name: "ALL TABLES INDIVIDUAL SOURCING by stockName",
            endpoint: "/data/quarterlyFundamentalStockData",
            note: "individual symbol sourcing for all quarterly tables, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "SymbolFinancialData Individual by stockName",
            endpoint: "/fetchSymbolFinancials/quarterly",
            note: "individual symbol sourcing for SymbolFinancialDataQuarterly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "symbolKeyMetrics Individual by stockName",
            endpoint: "/sourceSymbolKeyMetrics/quarterly",
            note: "individual symbol sourcing for stockkeymetricsdataquarterly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "symbolFinancialRatios Individual by stockName",
            endpoint: "/fetchLatestSymbolFinancialRatios/quarterly",
            note: "individual symbol sourcing for symbolfinancialratiosdataquarterly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "incomeStatement Individual by stockName",
            endpoint: "/latest/incomestatement/quarter",
            note: "individual symbol sourcing for IncomeStatementQuarterly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "incomeStatementGrowth Individual by stockName",
            endpoint: "/symbolIncomeStatementGrowth/quarterly",
            note: "individual symbol sourcing for IncomeStatementGrowthQuarterly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "BalancedSheetStatement Individual by stockName",
            endpoint: "/balancedSheetStatementLatestQuarterly",
            note: "individual symbol sourcing for BalancedSheetStatementQuarterly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
        ],
      },
    ],
  },

  table3: {
    header: "Industry and Sector leader selection Quarterly",
    mainNote:
      "Use this endpoints in case you want the Industry and sector level calculation to be persisted for the required date range.",
    sections: [
      {
        apis: [
          {
            name: "Sector Growth with Date Range",
            endpoint: "/calculateQuarterlySectorGrowthLatest",
            note: "Does calculation at sector level and updates the data for a specific date range provided.",
            needsDateRange: true,
          },
          {
            name: "Industry Market Share with Date Range",
            endpoint: "/calculateQuarterlyMarketShareLatest",
            note: "Does calculation at industrial level and update the data for specific date range provided.",
            needsDateRange: true,
          },
        ],
      },
    ],
  },

  table4: {
    header: "Yearly individual sourcing",
    mainNote:
      "If you have missing data for some stocks in Yearly tables use the 1st endpoint. The first endpoint will persist all Historically missing data for all Yearly tables alone, No need to hit the remaining endpoints.",
    sections: [
      {
        subtitle: "Source complete history of stock for yearly",
        apis: [
          {
            name: "ALL TABLES INDIVIDUAL SOURCING for yearly by stockName",
            endpoint: "/data/yearlyFundamentalStockData",
            note: "individual symbol sourcing for all yearly tables, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "SymbolFinancialDataYearly Individual by stockName",
            endpoint: "/fetchSymbolFinancials/yearly",
            note: "individual symbol sourcing for SymbolFinancialDataYearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "stockkeymetricsdatayearly Individual by stockName",
            endpoint: "/sourceSymbolKeyMetrics/yearly",
            note: "individual symbol sourcing for stockkeymetricsdatayearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "symbolfinancialratiosdatayearly Individual by stockName",
            endpoint: "/fetchLatestSymbolFinancialRatio/yearly",
            note: "individual symbol sourcing for symbolfinancialratiosdatayearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "IncomeStatementYearly Individual by stockName",
            endpoint: "/latest/incomestatement/annual",
            note: "individual symbol sourcing for IncomeStatementYearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "IncomeStatementGrowth Individual by stockName",
            endpoint: "/symbolIncomeStatementGrowthLatestYearly",
            note: "individual symbol sourcing for IncomeStatementGrowth, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "BalancedSheetStatementYearly Individual by stockName",
            endpoint: "/balancedSheetStatementLatestYearly",
            note: "individual symbol sourcing for BalancedSheetStatementYearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "BalancedSheetStatementGrowthYearly Individual by stockName",
            endpoint: "/balancedSheetStatementGrowthYearlyLatest",
            note: "individual symbol sourcing for BalancedSheetStatementGrowthYearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "CashFlowStatementYearly Individual by stockName",
            endpoint: "/cashFlowStatementYearlyLatest",
            note: "individual symbol sourcing for CashFlowStatementYearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
          {
            name: "CashFlowGrowthStatementYearly Individual by stockName",
            endpoint: "/cashFlowGrowthStatementYearlyLatest",
            note: "individual symbol sourcing for CashFlowGrowthStatementYearly, it persistes all missing data which is not present in database",
            needsStock: true,
          },
        ],
      },
    ],
  },
   table5: {
    header: "Industry and Sector leader selection Yearly",
    mainNote:
      "Use this endpoints in case you want the Industry and sector level calculation to be persisted for the required date range. Remember this will be running with Yearly Calculations All, no need to hit seperately unless you want to",
    sections: [
      {
        apis: [
          {
            name: "Sector Growth with Date Range",
            latestEndpoint: "/calculateYearlySectorGrowthLatest",
            completeEndpoint: "/calculateYearlySectorGrowth",
            note: "Does calculation at sector level and updates the data for Latest or FullHistorical.",
            needsDateRange: false,
            needsMode: true,
          },
          {
            name: "Industry Market Share with Date Range",
            latestEndpoint: "/calculateYearlyMarketShareLatest",
            completeEndpoint: "/calculateYearlyMarketShare",
            note: "Does calculation at industrial level and update the data for Latest or FullHistorical.",
            needsDateRange: false,
            needsMode: true,
          },
        ],
      },
    ],
  },

};

const AdHocIndividualSourcing = () => {
  const [stockInputs, setStockInputs] = useState({});
  const [monthYearInputs, setMonthYearInputs] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [dateInputs, setDateInputs] = useState({});
  const [modeInputs, setModeInputs] = useState({});

  const handleStockNameChange = (key, value) => {
    setStockInputs({ ...stockInputs, [key]: value });
  };

  const handleMonthYearChange = (key, value) => {
    setMonthYearInputs({ ...monthYearInputs, [key]: value });
  };

  const handleModeChange = (key, value) => {
    setModeInputs((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSourceClick = async (api, indexKey, tableKey) => {
    const stockName = stockInputs[indexKey];
    const fromDate = dateInputs[indexKey]?.from;
    const toDate = dateInputs[indexKey]?.to;

    let endpoint = api.endpoint;

if (tableKey === "table5") {
  const mode = modeInputs[indexKey] || "latest";

  endpoint =
    mode === "complete"
      ? api.completeEndpoint
      : api.latestEndpoint;
}

    let url = "";

    // ✅ Special condition for Source Daily Stock Price
    if (endpoint === "/data/sourceDailyStockPrice") {
      if (fromDate && toDate) {
        url = `${BASE_URL}/valuation?fromDate=${fromDate}&toDate=${toDate}`;
      } else if (stockName) {
        url = `${BASE_URL}${endpoint}?stockName=${stockName}`;
      } else {
        url = `${BASE_URL}${endpoint}`;
      }
    } else {
      // Default logic for other APIs
      url = `${BASE_URL}${endpoint}`;

      const params = new URLSearchParams();

      if (stockName) {
        params.append("stockName", stockName);
      }

      if (fromDate) {
        params.append("fromDate", fromDate);
      }

      if (toDate) {
        params.append("toDate", toDate);
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }
    }

    const xApiKey = sessionStorage.getItem("xApiKey");

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-API-KEY": xApiKey,
        },
      });

      if (!response.ok) throw new Error("API call failed");

      const data = await response.text();
      setModalMessage("Success: " + data);
      setShowModal(true);
    } catch (error) {
      setModalMessage("Error occurred while calling API.");
      setShowModal(true);
    }
  };

  const renderTable = (tableKey) => {
    const tableData = apiMap[tableKey];
    if (!tableData || !tableData.header) return null;

    const tableHasStock = tableData.sections.some((section) =>
      section.apis.some((api) => api.needsStock),
    );

    const tableHasMonthYear = tableData.sections.some((section) =>
      section.apis.some((api) => api.needsMonthYear),
    );

    const handleDateChange = (key, field, value) => {
      setDateInputs((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          [field]: value,
          ...(field === "from" && !prev[key]?.to && { to: value }),
        },
      }));
    };

    const tableHasDateRange = tableData.sections.some((section) =>
      section.apis.some((api) => api.needsDateRange),
    );

    return (
      <div className="container-fluid">
        <h3 className="fw-bold text-center mb-4">{tableData.header}</h3>
        {tableData.mainNote && (
          <div className="table-main-note">
            <strong>Note:</strong> {tableData.mainNote}
          </div>
        )}
        <div className="table-responsive mb-5">
          <table className="table custom-striped-table align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: "2%" }}>ID</th>
                <th style={{ width: "35%" }}>Scheduler Name</th>
                {tableHasStock && (
                  <th style={{ width: "10%" }} className="text-center">
                    Stock Name
                  </th>
                )}
                {tableHasDateRange && (
                  <th style={{ width: "10%" }} className="text-center">
                    From Date
                  </th>
                )}
                {tableHasDateRange && (
                  <th style={{ width: "10%" }} className="text-center">
                    To Date
                  </th>
                )}
                {tableHasMonthYear && (
                  <th style={{ width: "10%" }} className="text-center">
                    MonthYear
                  </th>
                )}
                {tableKey === "table5" && (
                  <th style={{ width: "10%" }} className="text-center">
                     Mode
                  </th>
                )}
                <th style={{ width: "15%" }} className="text-center">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {tableData.sections.map((section, secIndex) => (
                <React.Fragment key={secIndex}>
                  {/* Section Title Row */}
                  {section.subtitle && (
                    <tr className="section-subtitle-row">
                      <td
                        colSpan={
                          2 +
                          (tableHasStock ? 1 : 0) +
                          (tableHasDateRange ? 2 : 0) +
                          (tableHasMonthYear ? 1 : 0) +
                          1
                        }
                      >
                        <span className="section-subtitle">
                          {section.subtitle}
                        </span>
                      </td>
                    </tr>
                  )}
                  {section.title && (
                    <tr className="table">
                      <td
                        colSpan={
                          2 +
                          (tableHasStock ? 1 : 0) +
                          (tableHasDateRange ? 2 : 0) +
                          (tableHasMonthYear ? 1 : 0) +
                          1
                        }
                      >
                        <strong>{section.title}</strong>
                      </td>
                    </tr>
                  )}
                  {section.mainNote && (
                    <tr className="section-main-note">
                      <td
                        colSpan={
                          2 +
                          (tableHasStock ? 1 : 0) +
                          (tableHasMonthYear ? 1 : 0) +
                          1
                        }
                      >
                        <div className="">
                          <strong>Note:</strong> {section.mainNote}
                        </div>
                      </td>
                    </tr>
                  )}

                  {section.apis.map((api, index) => {
                    const indexKey = `${tableKey}-${secIndex}-${index}`;

                    return (
                      <tr key={indexKey}>
                        <td>{index + 1}</td>
                        <td>
                          {api.name}
                          {api.note && (
                            <span className="info-tooltip">
                              i<span className="tooltip-text">{api.note}</span>
                            </span>
                          )}
                        </td>

                        {tableHasStock && (
                          <td>
                            {api.needsStock && (
                              <input
                                className="form-control"
                                value={stockInputs[indexKey] || ""}
                                onChange={(e) =>
                                  handleStockNameChange(
                                    indexKey,
                                    e.target.value,
                                  )
                                }
                              />
                            )}
                          </td>
                        )}

                        {tableHasDateRange && (
                          <>
                            <td>
                              {api.needsDateRange && (
                                <input
                                  type="date"
                                  className="form-control"
                                  value={dateInputs[indexKey]?.from || ""}
                                  onChange={(e) =>
                                    handleDateChange(
                                      indexKey,
                                      "from",
                                      e.target.value,
                                    )
                                  }
                                />
                              )}
                            </td>

                            <td>
                              {api.needsDateRange && (
                                <input
                                  type="date"
                                  className="form-control"
                                  value={dateInputs[indexKey]?.to || ""}
                                  onChange={(e) =>
                                    handleDateChange(
                                      indexKey,
                                      "to",
                                      e.target.value,
                                    )
                                  }
                                />
                              )}
                            </td>
                          </>
                        )}

                        {tableHasMonthYear && (
                          <td>
                            {api.needsMonthYear && (
                              <input
                                className="form-control"
                                placeholder="MMMYYYY"
                                value={monthYearInputs[indexKey] || ""}
                                onChange={(e) =>
                                  handleMonthYearChange(
                                    indexKey,
                                    e.target.value,
                                  )
                                }
                              />
                            )}
                          </td>
                        )}
                        
                        {tableKey === "table5" && (
                          <td>
                            <select
                              className="form-select"
                              value={modeInputs[indexKey] || "latest"}
                              onChange={(e) =>
                                handleModeChange(indexKey, e.target.value)
                              }
                            >
                              <option value="latest">Latest</option>
                              <option value="complete">Complete</option>
                            </select>
                          </td>
                        )}

                        <td className="text-center">
                          <button
                            className="btn btn-primary"
                            onClick={() =>
                              handleSourceClick(api, indexKey, tableKey)
                            }
                          >
                            Source Data
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="section-gap">
                    <td
                      colSpan={
                        2 +
                        (tableHasStock ? 1 : 0) +
                        (tableHasMonthYear ? 1 : 0) +
                        1
                      }
                    ></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <div className="main-content" style={{ paddingTop: "50px" }}>
        {renderTable("table1")}
        {renderTable("table2")}
        {renderTable("table3")}
        {renderTable("table4")}
        {renderTable("table5")}
      </div>

      {showModal && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">API Response</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>{modalMessage}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default AdHocIndividualSourcing;
